"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const contentLoader_1 = __importDefault(require("components/cosmos/contentLoader"));
const translationContext_1 = require("configs/translationContext");
const mobx_react_1 = require("mobx-react");
const drippingService_1 = __importDefault(require("../services/drippingService"));
const stores_1 = require("../stores");
const mapStateToProps = (stores, props) => ({
    quizDetails: stores.DrippingFormStore.quizDetails.get(props.quizId)
});
const DrippingQuizDetails = ({ quizId, quizDetails }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    (0, react_1.useEffect)(() => {
        if (!(quizDetails === null || quizDetails === void 0 ? void 0 : quizDetails.classes) || !(quizDetails === null || quizDetails === void 0 ? void 0 : quizDetails.name)) {
            drippingService_1.default.fetchQuizDetails(quizId).then((quizDetails) => {
                stores_1.DrippingFormStore.addQuizDetails(quizId, quizDetails);
            });
        }
    }, [quizDetails, quizId]);
    return ((0, jsx_runtime_1.jsx)("div", { children: (quizDetails === null || quizDetails === void 0 ? void 0 : quizDetails.name) ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("strong", { className: "_mr-2", children: [t('general.quiz'), ':'] }), quizDetails === null || quizDetails === void 0 ? void 0 : quizDetails.name] })) : ((0, jsx_runtime_1.jsx)(contentLoader_1.default, { style: { height: 20 } })) }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(DrippingQuizDetails);
